/// <reference path="../types.d.ts" />
import * as React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import * as Sentry from "@sentry/browser";

// css 
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/css/bootstrap-grid.min.css";
import "react-redux-toastr/lib/css/react-redux-toastr.min.css";
import "react-bootstrap-typeahead/css/Typeahead.css";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "./css/open-iconic-bootstrap.min.css";
import "react-day-picker/lib/style.css";
import "./css/app.css";

// js libs
import "jquery/dist/jquery.slim";
import "bootstrap/dist/js/bootstrap.bundle";

if(process.env.REACT_APP_SENTRY_DSN){
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN// "https://f1833ae37a6242b1a3259ef3bb0534c8@sentry.io/1419296",
  });
}


// if local storage is set, we will want to set the info
if(window.localStorage.user){
  let user = window.localStorage.user;
  if(typeof user === "string"){
    user = JSON.parse(user);
  }
  const env = process.env.REACT_APP_ENV === "production" ? "production" : "develop";
  Sentry.configureScope((scope: any) => {
    scope.setExtra("environment", env);
    scope.setUser(user);
  });
}

ReactDOM.render(<App />, document.getElementById("root"));
serviceWorker.unregister();
